import { render, staticRenderFns } from "./PriceHistory.vue?vue&type=template&id=95240636&scoped=true&"
import script from "./PriceHistory.vue?vue&type=script&lang=js&"
export * from "./PriceHistory.vue?vue&type=script&lang=js&"
import style0 from "./PriceHistory.vue?vue&type=style&index=0&id=95240636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95240636",
  null
  
)

export default component.exports